import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Banner from "./components/Banner";
import HeroImageWithText from "./components/HeroImageWithText";

// Slick version
// import CarouselSection from "./components/CarouselSection";

// Non-Slick version
import Carousel from "./components/Carousel";
import EventsSection from "./components/EventsSection";
import ColabSection from "./components/ColabSection";
import PartnersSection from "./components/PartnersSection";
import FooterSection from "./components/Footer";
import EventDetailPage from "./components/EventDetailPage";
import "./style/global.css";

function HomePage() {
  return (
    <>
      <Banner />
      <HeroImageWithText />
      <Carousel title="Featured Cybersecurity Learning Modules" />
      <EventsSection />
      <ColabSection />
      <PartnersSection />
      <FooterSection />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/event/:id" element={<EventDetailPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
